import type { ReactNode } from 'react'
import { AtSignIcon } from '@systemeio/icons'
import { useSlate } from 'slate-react'
import { ToolbarButton } from '../../common/toolbar-button'
import { isMentionActive } from '../../utils/mention'

const MentionButton = ({ onClick }: { onClick: () => void }): ReactNode => {
  const editor = useSlate()
  const mentionActive = isMentionActive(editor)

  return (
    <ToolbarButton active={mentionActive} format="mention" onClick={onClick}>
      <AtSignIcon className="size-5 text-text-secondary hover:text-[initial] md:size-6" />
    </ToolbarButton>
  )
}

export default MentionButton
